import script from "./SankeyChart.vue?vue&type=script&setup=true&lang=js"
export * from "./SankeyChart.vue?vue&type=script&setup=true&lang=js"

import "./SankeyChart.vue?vue&type=style&index=0&id=83a17cfe&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-83a17cfe"]])

export default __exports__